var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "db" },
    [
      _c(
        "a",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.perksAreVisible,
              expression: "!perksAreVisible",
            },
          ],
          staticClass: "is-table-bold b ttu is-navy pointer",
          attrs: { title: "More perks" },
          on: {
            click: function ($event) {
              _vm.perksAreVisible = !_vm.perksAreVisible
            },
          },
        },
        [_vm._v("More Perks +")]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.perksAreVisible,
              expression: "perksAreVisible",
            },
          ],
          staticClass: "is-table-bold b ttu is-navy pointer",
          attrs: { title: "Hide perks" },
          on: {
            click: function ($event) {
              _vm.perksAreVisible = !_vm.perksAreVisible
            },
          },
        },
        [_vm._v("Hide Perks -")]
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade-rev" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.perksAreVisible,
                expression: "perksAreVisible",
              },
            ],
          },
          [_vm._t("perks-content")],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }